export const PARAMETER_LABELS = {
  administration: 'Administración',
  parameters: 'Parámetros',
  selectParameter: 'Seleccione un parámetro',
  notSelected: '-- Sin seleccionar --',
  code: 'Código',
  name: 'Nombre',
  parameter: 'Parámetro',
  createParameter: 'Crear parámetro',
  createSubParameter: 'Crear sub-parámetro',
  save: 'Guardar',
  cancel: 'Cancelar',
  close: 'Cerrar',
  edit: 'Editar',
  view: 'Ver',
  tableCode: 'CÓDIGO',
  tableName: 'NOMBRE',
  tableStatus: 'ESTADO',
  tableActions: 'ACCIONES',
  noData: 'No hay sub-parámetros registrados.',
  editSubParameter: 'Editar sub-parámetro',
  detailOf: 'Detalle del',
  subParameter: 'Sub-parámetro',
  internalCode: 'Código Interno',
  status: 'Estado',
  created: 'Creado',
  updated: 'Actualizado',
  deleted: 'Eliminado',
  description: 'Descripción',
  rangeFrom: 'Rango Desde',
  rangeTo: 'Rango Hasta',
  requiredField: 'Campo requerido',
  active: 'Activo',
  inactive: 'Inactivo',
  notAvailable: 'N/A'
};
